/*
 包含多个基于state的getter计算属性的对象
 */

export default {
  isLogin: state => state.token ? true : false,
  token: state => state.token,
  phone: state => state.phone
}



// WEBPACK FOOTER //
// ./src/store/getters.js